// import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
// import Login from "../features/login/Login";
// import { openDialog } from "../components/dialog/dialogSlice";
// import { useAppDispatch } from "../app/hooks";
import { Button } from "@progress/kendo-react-buttons";
// import LogIn from "../features/login/Login";
import { SuccessToast } from "../components/toast/Toasts";
import Country from "../features/country/Country";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Rights from "../features/rights/Rights";
import CreateRights from "../features/rights/CreateRights";
import Menu from "../features/menu/Menu";
import CreateMenu from "../features/menu/CreateMenu";
import City from "../features/city/City";
import State from "../features/state/State";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../features/dashboard/Dashboard";
import Agent from "../features/agent/Agent";
import NewPort from "../features/newport/NewPort";
import Line from "../features/line/Line";
import VesselsExportLoading from "../features/vesselsexportloading/VesselsExportLoading";
import CreateVesselsExportLoading from "../features/vesselsexportloading/CreateVesselsExportLoading";
import ContainerImportDischarge from "../features/containerimportdischarge/ContainerImportDischarge";
import CreateContainerImportDischarge from "../features/containerimportdischarge/CreateContainerImportDischarge";
import LoginNew from "../features/login/LoginNew";
import PortDataimportTable from "../features/portdataimport/PortDataimportTable";
import UploadPortDataimport from "../features/portdataimport/UploadPortDataimport";
import ShippingMovementsList from "../features/shippingmovementsList/ShippingMovementsList";
import CreateShippingMovementsList from "../features/shippingmovementsList/CreateshippingMovementsList";
// import CreateCountry from "../features/country/CreateCountry";

const MainRouter = () => {
  // const dispatch = useAppDispatch();
  return (
    <Routes>
      {/* <Route path="login" element={<LogIn />} /> */}
      <Route path="login" element={<LoginNew />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index={true} element={<Dashboard />} />
        <Route path="country" element={<Country />} />
        <Route path="city" element={<City />} />
        <Route path="state" element={<State />} />
        <Route path="user" element={<User />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="rights" element={<Rights />} />
        <Route path="rights/create" element={<CreateRights />} />
        <Route path="rights/edit" element={<CreateRights />} />
        <Route path="menu" element={<Menu />} />
        <Route path="menu/create" element={<CreateMenu />} />
        <Route path="menu/edit" element={<CreateMenu />} />
        <Route path="agent" element={<Agent />} />
        <Route path="port" element={<NewPort />} />
        <Route path="line" element={<Line />} />
        <Route path="shippingmovements" element={<ShippingMovementsList />} />
        <Route path="shippingmovements/create" element={<CreateShippingMovementsList />} />
        <Route path="shippingmovements/edit" element={<CreateShippingMovementsList />} />
        <Route path="vesselsexportloading" element={<VesselsExportLoading />} />
        <Route path="vesselsexportloading/create" element={<CreateVesselsExportLoading />} />
        <Route path="vesselsexportloading/edit" element={<CreateVesselsExportLoading />} />
        <Route path="containerimportdischarge" element={<ContainerImportDischarge />} />
        <Route path="containerimportdischarge/create" element={<CreateContainerImportDischarge />} />
        <Route path="containerimportdischarge/edit" element={<CreateContainerImportDischarge />} />
        <Route path="portimportdata" element={<PortDataimportTable />} />
        <Route path="portimportdata/uplod" element={<UploadPortDataimport />} />

        {/* <Route path="country/create" element={<CreateCountry />} />
        <Route path="country/edit" element={<CreateCountry />} /> */}
        <Route
          path="about"
          element={
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => SuccessToast("Hello")}
              // onClick={() => dispatch(openDialog("testDialog"))}
            >
              Hello
            </Button>
          }
        />
        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
